/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_TitleInputs */

const cs_gdpr_title = /** @type {(inputs: Gdpr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const en_gdpr_title = /** @type {(inputs: Gdpr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

/**
* | output |
* | --- |
* | "GDPR" |
*
* @param {Gdpr_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_title = /** @type {((inputs?: Gdpr_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_title(inputs)
	return cs_gdpr_title(inputs)
});